import { useState } from 'react'

export type ResultsDiagramType =
  | 'moment'
  | 'shear'
  | 'displacement'
  | 'axial'
  | 'axialDisp'
  | 'reactions'
  | 'ur'
  | 'strain'
  | 'stress'

export interface ResultsViewState
{
  selectedDiagram: ResultsDiagramType
  setSelectedDiagram: (diagram: ResultsDiagramType) => void
  showValues: boolean
  setShowValues: (value: boolean) => void
  showMaxMin: boolean
  setShowMaxMin: (value: boolean) => void
  valueDecimals: 2 | 4
  setValueDecimals: (value: 2 | 4) => void
  diagramScale: number
  setDiagramScale: (scale: number) => void
  valueDensity: number
  setValueDensity: (density: number) => void
  valueFontSize: number
  setValueFontSize: (size: number) => void
}

export default function useResultsViewState(): ResultsViewState
{
  const [selectedDiagram, setSelectedDiagram] = useState<ResultsDiagramType>('moment')
  const [showValues, setShowValues] = useState(true)
  const [showMaxMin, setShowMaxMin] = useState(true)
  const [valueDecimals, setValueDecimals] = useState<2 | 4>(2)
  const [diagramScale, setDiagramScale] = useState(1.0)
  const [valueDensity, setValueDensity] = useState(5)
  const [valueFontSize, setValueFontSize] = useState(10)

  return {
    selectedDiagram,
    setSelectedDiagram,
    showValues,
    setShowValues,
    showMaxMin,
    setShowMaxMin,
    valueDecimals,
    setValueDecimals,
    diagramScale,
    setDiagramScale,
    valueDensity,
    setValueDensity,
    valueFontSize,
    setValueFontSize
  }
}

